import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState('ar');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('preferred-language');
    if (savedLanguage && ['ar', 'en']?.includes(savedLanguage)) {
      setCurrentLanguage(savedLanguage);
    }
  }, []);

  const toggleLanguage = () => {
    const newLanguage = currentLanguage === 'ar' ? 'en' : 'ar';
    setCurrentLanguage(newLanguage);
    localStorage.setItem('preferred-language', newLanguage);
  };

  const setLanguage = (language) => {
    if (['ar', 'en']?.includes(language)) {
      setCurrentLanguage(language);
      localStorage.setItem('preferred-language', language);
    }
  };

  const isRTL = currentLanguage === 'ar';
  const isArabic = currentLanguage === 'ar';
  const isEnglish = currentLanguage === 'en';

  const value = {
    currentLanguage,
    toggleLanguage,
    setLanguage,
    isRTL,
    isArabic,
    isEnglish,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;